module.exports = __webpack_public_path__ + "img/logo.6200884c.png";